import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { routes } from "consts";
import { PaziaButton, PaziaLoader } from "components/atoms";
import { useCourseStudentsExams } from "api/course-exams";
import { useCourse } from "api/hooks";
import { SendExamResultsModal } from "./SendExamResultsModal";
import { StudentExamsTable } from "./StudentExamsTable";

export const CourseExamsPage = () => {
  const { courseId, courseExamId } = useParams();
  const [selectedExams, setSelectedExams] = useState<number[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const { isLoading, exams, name } = useCourseStudentsExams(Number(courseId), Number(courseExamId));
  const { data: course } = useCourse(Number(courseId));

  if (isLoading) return <PaziaLoader position="center" />;
  if (!name) return null;

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Kursy", path: routes.COURSES },
          { title: [name, course?.data.variant].filter(Boolean).join(" · "), path: routes.COURSES_MANAGE(courseId) },
          { title: "Wyniki egzaminów" },
        ]}
        headerButton={
          <PaziaButton
            type="secondary"
            disabled={selectedExams.length < 1}
            onClick={() => setIsOpen(true)}
            btnType="button"
          >
            Wyślij wyniki
          </PaziaButton>
        }
        headerText="Wyniki egzaminów"
      />

      <StudentExamsTable
        exams={exams}
        courseId={Number(courseId)}
        courseExamId={Number(courseExamId)}
        setSelectedExams={setSelectedExams}
      />

      <SendExamResultsModal
        isOpen={isOpen}
        students={exams}
        selected={selectedExams}
        onCloseRequest={() => setIsOpen(false)}
        courseId={Number(courseId)}
        courseExamId={Number(courseExamId)}
      />
    </PageMain>
  );
};
